import React from 'react'
import brandLine from "./../assets/BrandLineBlue.png"
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const newdate = new Date();
  const currentYear = newdate.getFullYear();
  
  return (
    <footer className='footer'>
      
      <div className='brandline'><img src={brandLine } alt="logo" /></div>
      <div>{t('Legal and Human Rights Centre')} &copy; {currentYear }</div>
    </footer>
  )
}

export default Footer